<template>
	<v-menu
		v-model="isActiveCreatingFavoriteLinkMenu"
		:close-on-content-click="false"
	>
		<template v-slot:activator="{ props }">
			<ao-icon-btn
				v-bind="props"
				size="small"
				iconName="links"
				color="accent"
				class="mr-1"
				:disabled="!isLoadedFavoritesStatus"
			/>
		</template>
		<FavoriteLinkForm
			:loading="isCreatingFavoriteLinkStatus"
			:groups="groups"
			:currentRoute="route"
			@saveLink="onSaveLink"
			@cancel="isActiveCreatingFavoriteLinkMenu = false"
		/>
	</v-menu>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'

import FavoriteLinkForm from '@/components/favorites/FavoriteLinkForm.vue'

import { useCompanyFavoriteLinksStore } from '@/stores/companyFavoriteLinksStore'

const route = useRoute()

const companyFavoriteLinksStore = useCompanyFavoriteLinksStore()
const {
	favoritesLinks,
	isLoadedFavoritesStatus,
	isCreatingFavoriteLinkStatus,
} = storeToRefs(companyFavoriteLinksStore)
const {
	createFavoriteLink,
} = companyFavoriteLinksStore

const groups = computed(() => {
	return favoritesLinks.value.groups.map((group) => {
		return {
			name: group.name,
			key: group.key,
		}
	})
})

const isActiveCreatingFavoriteLinkMenu = ref(false)

const onSaveLink = (payload) => {
	createFavoriteLink(payload.groupKey, {
		title: payload.title,
		subtitle: payload.subtitle,
	})
		.then(() => {
			isActiveCreatingFavoriteLinkMenu.value = false
		})
}
</script>

<style lang="scss">
// .header_favourites {
// 	:global(.v-label.v-field-label) {
// 		font-size: 12px;
// 		top: 24px;
// 	}

// 	:global(.v-field-label.v-field-label--floating) {
// 		top: var(--v-input-padding-top, 10px);
// 	}

// 	:global(.bg-secondary) {
// 		background: #f0f4f7 !important;
// 		color: rgba(0, 0, 0, 0.2) !important;
// 	}

// 	.folder {
// 		color: #576674;
// 	}

// 	.chip_text {
// 		color: #22282b;
// 	}
// }
</style>
